export default [{ method: "get", path: "/ContractReporting/" }];
